export enum orderStatusEnum {
  ENTERED = 1,
  DELIVERED = 2,
  ANNULLED = 13,
}
